import { Mail, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automatePhoneCallingFromEmailAr: TemplateAr = {
  name: 'أتمتة الاتصال الهاتفي من الإيميل بالذكاء الاصطناعي',
  description:
    'لمّا تحتاج محادثة الإيميل تدخّلاً عاجلاً، يطلق الذكاء الاصطناعي مكالمة متابعة تلقائياً لتنحلّ المشكلة أسرع.',
  category: 'دعم العملاء',
  workflow: [
    { icon: Mail, label: 'خيط إيميل' },
    { icon: Sparkles, label: 'إطلاق ذكي' },
    { icon: Phone, label: 'مكالمة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ارفع الخيط للتلفون لمّا يلف في حلقة مفرغة، مو تنتظر رد رابع. الـ AI يقرأ طول خيط الإيميل، وتأخر الردود، وإشارات انزعاج العميل، وتعقيد المشكلة، عشان يحدد متى يكون الصوت أسرع في حل المشكلة. ثم يطلق المكالمة، ويجدولها، ويعطي الموظف سياق الإيميل كامل.',
    paragraph2:
      'الإطلاق والجدولة تجري بالأدوات اللي تفضّلها أنت — دعوات التقويم، أو تنبيهات Slack، أو الربط مع نظام الهاتف عندك. ونتيجة المكالمة تنزل تلقائياً في تذكرة الإيميل نفسها. والـ AI يتعلّم أي المواقف تستفيد أكثر من التصعيد الصوتي.',
  },
  benefits: [
    'اقطع الخيط المتعثر بمكالمة وحدة',
    'الـ AI يرصد الانزعاج قبل ما يتصاعد',
    'خلّص عميلك من تبادل الإيميلات الطويل',
    'الموظف يتصل ومعه سياق الإيميل كامل',
    'وقت الحل ينزل وتلاحظ الفرق',
    'نتيجة كل مكالمة تنزل في التذكرة تلقائياً',
  ],
};
